import styled from '@emotion/styled';
import { Switch } from '@paypalcorp/pp-react-switch-weasley-v7';

export const OnboardSwitch = styled(Switch)`
  span {
    font-size: 14px;
    font-weight: 600;
  }
`;
